import { useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';

export const useDocumentTitle = (titleEn: string, titleFr?: string) => {
  const { language } = useLanguage();
  const baseTitle = 'Dynovant Systems';

  useEffect(() => {
    const pageTitle = language === 'en' 
      ? titleEn 
      : (titleFr || titleEn);
    
    document.title = pageTitle === 'home' 
      ? baseTitle + ' | AI & Automation Solutions'
      : `${baseTitle} | ${pageTitle}`;

    return () => {
      document.title = baseTitle;
    };
  }, [titleEn, titleFr, language]);
}; 